export enum EnumMyCourseMenu {
  /** 林曦老师亲授 */
  Teach = 'teach',
  /** 林曦老师监制 */
  Product = 'product',
  /** 线下课 */
  Offline = 'offline'
}

export enum EnumMyStudyMenu {
  /** 作业 */
  Homework = 'homework',
  /** 作品 */
  Reward = 'reward',
  /** 日常 */
  Daily = 'daily',
  /** 收藏 */
  Collect = 'collect'
}

export enum EnumMyAccountMenu {
  /** 订单 */
  Order = 'order',
  /** 笔山 */
  Bishan = 'bishan',
  /** 桐板儿 */
  Coin = 'coin',
  /** 卡劵 */
  Packs = 'packs',
  /** 兑换 */
  Exchange = 'exchange'
}

export enum EnumContentType {
  /** 书法课 */
  Calligraphy = '1',
  /** 画画课 */
  Painting = '5',
  /** 书画课 */
  CalligraphyAndReading = '7',
  /** 美育 */
  AestheticEducation = '8'
}

export enum EnumProductType {
  /**
   * 系列课
   */
  Series = '1',
  /**
   * 专题课
   */
  SpecialTopic = '2',
  /**
   * 教练日课
   */
  DayCourse = '3',
  /**
   * 自习课
   */
  SelfStudy = '4',
  /**
   * 暄桐展览
   */
  Exhibition = '5'
}
